import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook, MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, NAV, SERVICES } from "../data/site";

const socials = [
  { icon: Linkedin, label: "LinkedIn", href: "#" },
  { icon: Instagram, label: "Instagram", href: "#" },
  { icon: Facebook, label: "Facebook", href: "#" },
  { icon: MessageCircle, label: "WhatsApp", href: `https://wa.me/${COMPANY.phoneRaw.replace("+", "")}` },
];

export const Footer = () => (
  <footer className="bg-navy text-white" data-testid="footer">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-24">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div className="lg:pr-8">
          <Logo light />
          <p className="mt-5 text-sm text-white/60 leading-relaxed">
            {COMPANY.tagline}. Reliable cross-docking, short-term warehousing, freight handling and
            LTL pickup-and-delivery from our Mississauga facility.
          </p>
          <div className="flex gap-3 mt-6">
            {socials.map((s) => (
              <a key={s.label} href={s.href} aria-label={s.label} target="_blank" rel="noopener noreferrer"
                 data-testid={`social-${s.label.toLowerCase()}`}
                 className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-orange hover:border-orange transition-colors">
                <s.icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="tag-eyebrow mb-5">Navigation</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm text-white/70 hover:text-orange transition-colors">{n.label}</Link>
              </li>
            ))}
            <li><Link to="/quote" className="text-sm text-white/70 hover:text-orange transition-colors">Request a Quote</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="tag-eyebrow mb-5">Services</h4>
          <ul className="space-y-3">
            {SERVICES.slice(0, 7).map((s) => (
              <li key={s.slug}>
                <Link to="/services" className="text-sm text-white/70 hover:text-orange transition-colors">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="tag-eyebrow mb-5">Contact</h4>
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex gap-3"><MapPin size={18} className="text-orange shrink-0 mt-0.5" />
              <span>{COMPANY.name}<br />{COMPANY.address}<br />{COMPANY.city}</span></li>
            <li><a href={`tel:${COMPANY.phoneRaw}`} className="flex gap-3 hover:text-orange transition-colors">
              <Phone size={18} className="text-orange shrink-0" /> {COMPANY.phone}</a></li>
            <li><a href={`mailto:${COMPANY.email}`} className="flex gap-3 hover:text-orange transition-colors">
              <Mail size={18} className="text-orange shrink-0" /> {COMPANY.email}</a></li>
            <li className="text-white/50">{COMPANY.hours}</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
        <p>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-orange transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-orange transition-colors">Terms & Conditions</Link>
          <Link to="/admin" className="hover:text-orange transition-colors">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);
